/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export type PatientPrescriptionItemRxFillStatus =
  | (typeof PatientPrescriptionItemRxFillStatus)[keyof typeof PatientPrescriptionItemRxFillStatus]
  | null;

export const PatientPrescriptionItemRxFillStatus = {
  filled: "filled",
  partial_filled: "partial_filled",
} as const;
